module.exports = __webpack_public_path__ + "static/img/rifle-cartridge_256.cd5520f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rifle-cartridge_256.png
// module id = msLJ
// module chunks = 0